<template>
    <div class="n2-center-container">


    </div>
</template>

<script>
    

    export default {

    }
</script>
<style lang="scss" scoped>
</style>
